import { render } from "./Ordenes_CompraView.vue?vue&type=template&id=b90d93ce"
import script from "./Ordenes_CompraView.vue?vue&type=script&lang=js"
export * from "./Ordenes_CompraView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__